import { render, staticRenderFns } from "./WorkHeader.vue?vue&type=template&id=2d6b381e&scoped=true&"
import script from "./WorkHeader.vue?vue&type=script&lang=js&"
export * from "./WorkHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkHeader.vue?vue&type=style&index=0&id=2d6b381e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b381e",
  null
  
)

export default component.exports